/** @format */

import {useTranslation} from 'react-i18next';

import {Container, Icon, Body, Title, Description} from './styles';

export type BalanceCalloutState = 'never_purchased' | 'exhausted';

interface Props {
  state: BalanceCalloutState;
}

const COPY: Record<
  BalanceCalloutState,
  {iconName: string; titleKey: string; descriptionKey: string}
> = {
  never_purchased: {
    iconName: 'lightbulb_2',
    titleKey: 'Пополните баланс ИИ-исследований',
    descriptionKey:
      'Вы можете пополнить баланс на одно или сразу несколько исследований и свободно заказывать их',
  },
  exhausted: {
    iconName: 'lock_clock',
    titleKey: 'У вас закончились ИИ-исследования',
    descriptionKey:
      'Вы можете пополнить баланс на одно или сразу несколько исследований и свободно заказывать их',
  },
};

const BalanceCallout = ({state}: Props) => {
  const {t} = useTranslation();
  const copy = COPY[state];

  return (
    <Container customState={state} data-testid='balance-callout' data-state={state}>
      <Icon
        component='span'
        className='material-symbols-outlined'
        customState={state}
        data-testid='balance-callout-icon'
      >
        {copy.iconName}
      </Icon>
      <Body>
        <Title>{t(copy.titleKey)}</Title>
        <Description>{t(copy.descriptionKey)}</Description>
      </Body>
    </Container>
  );
};

export default BalanceCallout;
